import React from 'react';
import Header from './Header';
// import Footer from './Footer';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className='app' >
            <Header />
            <div className="app-wrapper">
                <div className="app-content pt-3 p-md-3 p-lg-4">
                    <div className="container-xl">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;
